import { Link } from "react-router-dom";
import { Button } from "./ui/button";

export default function CTASection() {
  return (
    <div className="mt-16 p-8 bg-gradient-to-br from-[#0f0f0f] to-[#1a1410] border border-[#d4af69]/20 rounded-lg text-center">
      <h3 className="text-2xl font-light mb-4 text-[#e8dcc4]" style={{ fontFamily: 'Cormorant Garamond, serif' }}>
        Ready to Get Started?
      </h3>
      <p className="text-gray-400 mb-6 max-w-xl mx-auto">
        Connect with us to explore mutual fund and SIF distribution opportunities tailored to your investment goals.
      </p>
      <Link to="/contact">
        <Button size="lg" className="bg-[#d4af69] hover:bg-[#c29d5a] text-[#0d1117] font-medium px-12 py-6 text-base tracking-wider uppercase shadow-lg shadow-[#d4af69]/20 hover:shadow-[#d4af69]/40 transition-all">
          Contact Us
        </Button>
      </Link>
    </div>
  );
}
